/**
 * InspectionTemplateIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const InspectionTemplateIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M15.808 12.143a1.79 1.79 0 0 1 2.366-.008l4.35 3.76a.8.8 0 0 1-.665 1.391v3.204c0 .992-.808 1.8-1.8 1.8h-6.05a1.796 1.796 0 0 1-1.799-1.8v-3.232a.798.798 0 0 1-.742-1.374zm1.318 1.2a.19.19 0 0 0-.253-.006l-.01.009-3.053 2.631v4.513c0 .113.087.2.2.2h6.05c.108 0 .2-.092.2-.2v-4.438l-3.133-2.707z"
      clipRule="evenodd"
    />
    <path d="M16 1.2c3.2 0 5.8 2.587 5.8 5.8v4a.8.8 0 1 1-1.6 0V7c0-2.327-1.88-4.2-4.2-4.2H8A4.19 4.19 0 0 0 3.8 7v8c0 2.32 1.873 4.2 4.2 4.2h2l.082.004a.8.8 0 0 1 0 1.592L10 20.8H8A5.795 5.795 0 0 1 2.2 15V7c0-3.212 2.588-5.8 5.8-5.8z" />
    <path d="M9.268 11.024a.8.8 0 0 1 1.007 1.24l-1.83 1.65a.8.8 0 0 1-.95.09l-.121-.09-.91-.82-.058-.058a.8.8 0 0 1 1.13-1.13l.373.336 1.295-1.166zm0-4.994a.8.8 0 0 1 1.007 1.239l-1.83 1.65a.8.8 0 0 1-.95.09l-.121-.09-.91-.82-.058-.058a.8.8 0 0 1 1.13-1.13l.373.336 1.295-1.166zm7.814 1.174a.8.8 0 0 1 0 1.592L17 8.8h-4a.8.8 0 1 1 0-1.6h4z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const InspectionTemplateIcon = makeIcon('InspectionTemplateIcon', InspectionTemplateIconSvg)
